import React from 'react';
import {useWellniteAudios} from 'hooks';
import {useTranslation} from 'react-i18next';

import {AudioList} from '../../Audio/components/AudioList';

interface ArticleListProps {
  userId: string;
  role: string;
}

export function ProviderAudioList({
  userId,
  role,
}: ArticleListProps): React.ReactElement {
  const {
    audios,
    handlePlay,
    currentlyPlayingId,
    isLoadingAudios,
    handleAudioClick,
  } = useWellniteAudios(userId, 20, role);

  const {t} = useTranslation();

  return (
    <AudioList
      title={t('wellniteContent.directBookingAudiosTitle', 'My Audios')}
      audios={audios ?? []}
      currentlyPlayingId={currentlyPlayingId}
      isLoadingAudios={isLoadingAudios}
      max={3}
      handlePlay={handlePlay}
      handleAudioClick={handleAudioClick}
    />
  );
}
